
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import { harajukuKevelosKevelosTopImage } from "@src/constants/images";
import InstaImage from "@src/components/InstaImage";
import { murakamiMasanori } from "@src/constants/authors";
import GoogleMap from "@src/components/GoogleMap";
export const meta = {
  path: "/media/harajuku/kevelos",
  title: "【お得情報】ピザ・ケベロス(KEVELOS)のランチメニューや支払い方法についてご紹介！",
  description: "原宿・表参道で本格的なピザが食べられるケベロス(KEVELOS)の、ランチメニュー、支払い方法、予約方法についてご紹介させていただきます！「マリナーラがおいしい！」「釜でピザを焼く」ということはわかったけど、肝心の値段、支払い、予約についての情報はまた調べないといけない。というような悩みを全てこちらで解決できる内容になっていいます！",
  topImg: harajukuKevelosKevelosTopImage,
  author: murakamiMasanori,
  tags: ["原宿", "お店の紹介", "デート", "イタリアン", "裏原"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿・表参道で本格的なピザが食べられるケベロス(KEVELOS)は、平日にランチメニューを食べるのが圧倒的にお得になります！`}</p>
    <p>{`そのランチメニューが普通の値段とどれくらい違うのかを`}<strong parentName="p">{`写真付き`}</strong>{`でまとめています！
また、「クレカは使えるの？」「電子マネーは使えるの？」という支払いの部分や、「ランチ予約はできるの？」といった予約のところまでご紹介させていただきます！`}</p>
    <p>{`ケベロス(KEVELOS)を事前に知って、楽しいランチタイムにしましょう！`}</p>
    <h2>{`平日ランチが圧倒的にお得！(11:30~15:00)`}</h2>
    <p>{`ケベロス(KEVELOS)で安くお得な値段でピザランチを食べるなら、`}<strong parentName="p">{`平日ランチメニュー`}</strong>{`がオススメです！
平日のランチ以外でピザを頼むと、単品でもお値段がはります。
平日ランチメニューを紹介する際に、`}<strong parentName="p">{`通常メニューの値段も記載`}</strong>{`しますので、ご確認ください！
今日は、ケベロスのピザセットを`}<strong parentName="p">{`8 つ全て`}</strong>{`ご紹介します！`}</p>
    <h2>{`平日のランチセットは「サラダ」と「ピーチティー付き」`}</h2>
    <p>{`ケベロス(KEVELOS)の平日ランチセットは、サラダとピーチティーがついているメニューになります！
ピーチティーはなんと:`}<strong parentName="p">{`飲み放題`}</strong>{`になっていますので、平日ランチならではのお得感がありますよね。
これからご紹介するメニューは全て、サラダとピーチティーがついています！`}</p>
    <h2>{`ランチメニューピザ８選`}</h2>
    <h3>{`日替わりピザセット(税込：1,000 円)`}</h3>
    <InstaImage postId="BvwCUWgAVwr" mdxType="InstaImage" />
    <p>{`ケベロス(KEVELOS)オーナーが厳選したこだわりの食材で作る、ランチ限定のピザになります！`}</p>
    <h4>{`ハロウィンにこんな限定ピザが出ていたり！？`}</h4>
    <InstaImage postId="BaQSARQjyEd" mdxType="InstaImage" />
    <p>{`これはケベロス(KEVELOS)がハロウィン限定に提供していたピザ！
こういったピザが出てくると考えると、平日限定メニュー「日替わりピザセット」を頼んでみるのもいいですね！`}</p>
    <hr></hr>
    <h3>{`マリナーラセット(税込：1,000 円)`}</h3>
    <h4>{`通常価格：1,300 円`}</h4>
    <InstaImage postId="B-Zr1RslN5R" mdxType="InstaImage" />
    <p>{`「トマト、バジル、熟成ニンニク、オレガノ(ハーブのような葉っぱ)」の４種類しか使わないシンプルなピザ「マリナーラ」。
このピザがなんと`}<strong parentName="p">{`ケベロス(KEVELOS)の 1 番人気`}</strong>{`！
シンプルだからこそそのお店の実力が問われるマリナーラ。`}</p>
    <hr></hr>
    <h3>{`フィレマリナーラ　セット(税込：1,200 円)`}</h3>
    <h4>{`通常価格：1,500 円`}</h4>
    <InstaImage postId="B0KdOrSBoHw" mdxType="InstaImage" />
    <InstaImage postId="BKajepyjZMu" mdxType="InstaImage" />
    <p>{`マリナーラをベースとして、チェリートマト加わったの甘みと酸味のあるピザ！
シンプル故にピッツァメニューの中で一番テクニックを要するピザで、ケベロス(KEVELOS)の常連さんに人気のピザになってます！`}</p>
    <hr></hr>
    <h3>{`マルゲリータセット(税込：1,200 円)`}</h3>
    <h4>{`通常価格：1,500 円`}</h4>
    <InstaImage postId="B2UA6RAlSg-" mdxType="InstaImage" />
    <InstaImage postId="B8JBTWMHpmt" mdxType="InstaImage" />
    <p>{`とろとろのモッツァレラチーズ、トマト、バジルで作る王道のピザになります！
いつも食べている基本のピザが食べたい方にはオススメのピザです！`}</p>
    <hr></hr>
    <h3>{`ロマーナセット(税込：1,500 円)`}</h3>
    <h4>{`通常価格：1,800 円`}</h4>
    <InstaImage postId="B99XSMlpx7G" mdxType="InstaImage" />
    <p>{`マルゲリータをベースとして、アンチョビとチェリートマトを追加したピザ。
アンチョビの塩っけが、ビールやワインと相性ピッタリのピザになります！`}</p>
    <hr></hr>
    <h3>{`ジョバーナセット(税込：1,800 円)`}</h3>
    <h4>{`通常価格：2,000 円`}</h4>
    <InstaImage postId="B0AMAyGhknv" mdxType="InstaImage" />
    <p>{`水耕栽培のレタスとイタリア・パルマ産の生ハムを乗せたピザ。
モッツァレラチーズと生ハムを、さっぱりとしたレタスがしめてくれるピザになります！`}</p>
    <hr></hr>
    <h3>{`ビスマルクセット(税込：1,800 円)`}</h3>
    <h4>{`通常価格：2,100 円`}</h4>
    <InstaImage postId="B88j642ghsU" mdxType="InstaImage" />
    <p>{`とろとろの半熟卵と生ハムの塩分の相性が抜群のピザ！
この半熟卵は窯焼きで作っているので、香ばしさが漂うところも特徴です！`}</p>
    <hr></hr>
    <h3>{`ウルティマ　セット(税込：1,300 円)`}</h3>
    <h4>{`通常価格：1,500 円`}</h4>
    <InstaImage postId="B8yqagOHr50" mdxType="InstaImage" />
    <p>{`窯焼きの香ばしいキャラメルピザにジェラートを添えたデザートピザになります！
生キャラメルのような濃厚な旨味とアイスの甘み、生地の塩気は抜群の相性です。`}</p>
    <hr></hr>
    <h2>{`平日ランチの支払いは現金のみ！？`}</h2>
    <p>{`原宿・表参道エリアなので、クレジットカードや電子マネーで支払いをするつもりの方も多いと思いますが、ランチの時間は`}<strong parentName="p">{`現金のみ`}</strong>{`の支払いになっております。
当日に行って、クレカが使えない！電子マネーが使えない！ということにならないように、現金をご持参ください！`}</p>
    <hr></hr>
    <h2>{`ランチの予約はできない！？`}</h2>
    <p>{`ケベロス(KEVELOS)はディナーのみの予約となっており、ランチタイムは予約ができません！
食べログでも 3.7 以上の人気のお店なので、ランチの予約ができないとなると、`}<strong parentName="p">{`どの時間帯に行くか`}</strong>{`は気をつけたほうがいいです。`}</p>
    <p>{`オススメの時間帯は開店前の`}<strong parentName="p">{`11:30~12:00`}</strong>{`か閉店前の`}<strong parentName="p">{`14:00~14:30`}</strong>{`が狙い目の時間になります！
ピザなので回転も早くはないので、注意してください！`}</p>
    <hr></hr>
    <h2>{`アクセス`}</h2>
    <p>{`ケベロス(KEVELOS)は`}<strong parentName="p">{`原宿駅、表参道駅の中間地点`}</strong>{`にあり、どちらも`}<strong parentName="p">{`徒歩５分`}</strong>{`の好立地にあります！
比較的迷わずに行くことができると思います！`}</p>
    <GoogleMap lat={35.666367} lng={139.7026683} mdxType="GoogleMap" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`ケベロス(KEVELOS)のランチメニュー、支払い方法、予約についてご紹介してきました！
予想外のことも多いと思いますので、記事を確認してからお越しください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;